import React from "react";
import { MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { DESTINATIONS } from "../mock";
import SectionHeader from "./SectionHeader";
import useReveal from "../hooks/useReveal";

export default function Destinations() {
  const { t, S } = useLang();
  const ref = useReveal();

  return (
    <section id="destinos" ref={ref} className="py-20 md:py-28 section-tint">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeader kicker={t(S.destinations.kicker)} title={t(S.destinations.title)} sub={t(S.destinations.sub)} />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {DESTINATIONS.map((d, i) => (
            <div
              key={d.id}
              className="group relative rounded-2xl overflow-hidden card-lift reveal h-72"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <img src={d.img} alt={t(d.name)} className="absolute inset-0 w-full h-full object-cover img-zoom" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#042f37]/90 via-[#042f37]/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="inline-block text-[12px] font-semibold text-accent bg-white/15 backdrop-blur px-3 py-1 rounded-full border border-white/25">
                  {t(d.tag)}
                </span>
                <h3 className="mt-3 font-display font-bold text-xl text-white flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-accent" />
                  {t(d.name)}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
